import React from "react";
import "./home.css";
import Me from "../../assets/avatar-1.svg";
import HeaderSocials from "./HeaderSocials";
import DownScroll from "./DownScroll";
import Shapes from "./Shapes";

const Home = () => {
  return (
    <section className="home container" id="home">
      <div className="intro">
        <img src={Me} alt="" className="home__img" width={145} />
        <h1 className="home_name">Saloni Verma</h1>
        <span className="home__education">I'm a UI/UX Developer</span>

        <HeaderSocials />

        <a href="#contact" className="btn">
          Hire Me
        </a>
        <DownScroll />
      </div>
      <Shapes />
    </section>
  );
};

export default Home;
